import { forwardRef, FC, InputHTMLAttributes } from 'react';
import { Color, Colors, ColorsDictionary } from '../../types/ui';

const RadioButtonColors: Readonly<ColorsDictionary> = {
    [Colors.Primary]: 'text-blue-600',
    [Colors.Info]: 'text-purple-600',
    [Colors.Secondary]: 'text-gray-600',
    [Colors.Dark]: 'text-gray-900',
    [Colors.Warning]: 'text-yellow-600',
    [Colors.Danger]: 'text-red-600',
    [Colors.Success]: 'text-green-600',
};

type RadioButtonProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'color'> & {
    color: Color;
};

const RadioButton: FC<RadioButtonProps> = 
    forwardRef<HTMLInputElement, RadioButtonProps>((
        {
            children,
            color,
            className,
            ...rest
        }: RadioButtonProps,
        ref
    ) => {
        return (
            <label className={className ? className : "inline-flex items-center my-1"}>
                <input
                    ref={ref}
                    type="radio"
                    className={`form-radio h-5 w-5 ${RadioButtonColors[color]}`}
                    {...rest}
                />
                <span
                    className="ml-2 text-gray-700"
                >
                    {children}
                </span>
            </label>
        );
    });

RadioButton.displayName = 'RadioButton';

export default RadioButton;
